"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AvatarSizes = void 0;
/* eslint-disable max-len */
/**
 * Supported avatar image sizes. See
 * [developer.domo.com](https://developer.domo.com/docs/dev-studio-references/user-api#User%20Avatar)
 * for more details
 *
 * [1](https://developer.domo.com/docs/dev-studio-references/user-api#User%20Avatar)
 */
var AvatarSizes;
(function (AvatarSizes) {
    AvatarSizes["small"] = "100";
    AvatarSizes["medium"] = "180";
    AvatarSizes["large"] = "210";
    AvatarSizes["xLarge"] = "600";
    AvatarSizes["scale400"] = "400w";
    AvatarSizes["scale1920"] = "1920w";
})(AvatarSizes = exports.AvatarSizes || (exports.AvatarSizes = {}));
